function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ff4646",
  d: "M24401.98-5503a1.677 1.677 0 0 1-1.592-1.769v-12.136h12.48v12.136a1.673 1.673 0 0 1-1.592 1.769zm7.154-12.029v9.286a.393.393 0 0 0 .395.393.393.393 0 0 0 .393-.393v-9.286a.393.393 0 0 0-.393-.391.394.394 0 0 0-.394.389zm-2.9 0v9.286a.391.391 0 0 0 .393.393.393.393 0 0 0 .4-.393v-9.286a.393.393 0 0 0-.4-.391.391.391 0 0 0-.391.389zm-2.9 0v9.286a.393.393 0 0 0 .393.393.392.392 0 0 0 .393-.393v-9.286a.392.392 0 0 0-.393-.391.393.393 0 0 0-.391.389zm-3.352-2.662a.986.986 0 0 1-.982-.982.986.986 0 0 1 .982-.983h13.291a.98.98 0 0 1 .979.983.98.98 0 0 1-.979.982zm9.887-2.359v-1.129a1.023 1.023 0 0 0-1.059-1.033h-4.365a1.028 1.028 0 0 0-1.062 1.033v1.129h-.787v-1.129a1.814 1.814 0 0 1 1.85-1.819h4.365a1.812 1.812 0 0 1 1.846 1.819v1.129z",
  transform: "translate(-24391.5 5528)"
});

function SvgIconDeleteImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteImage);
export default __webpack_public_path__ + "static/media/iconDeleteImage.cb40c4de.svg";
export { ForwardRef as ReactComponent };